import { Component, Input, OnInit, EventEmitter, Output } from '@angular/core';
import { AppConfigService } from '@app/shared/services/app-config.service';
import { NzMessageService } from 'ng-zorro-antd/message';
import {
  FileType,
  FileTypesData,
  MediaStructure,
} from '../shared/interfaces/MediaStructure';
import { MediaService } from '../shared/services/Media.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
@Component({
  selector: 'app-media, [app-media]',
  templateUrl: './Media.component.html',
  styleUrls: ['./Media.component.less'],
})
export class MediaComponent implements OnInit {
  private _mediaStructure: MediaStructure;
  public get mediaStructure(): MediaStructure {
    return this._mediaStructure;
  }
  @Input()
  public set mediaStructure(value: MediaStructure) {
    this._mediaStructure = value;
  }
  //@Input() size: number;
  @Output() preview = new EventEmitter();
  @Output() download = new EventEmitter();
  @Output() remove = new EventEmitter();
  @Output() RoleChanges = new EventEmitter();
  @Output() CloseDrawer = new EventEmitter();
  isImage: boolean;
  DrawerVisible: boolean;
  fileType: FileType;
  url = AppConfigService.settings.baseUrl;
  constructor(private message: NzMessageService,private sanitizer: DomSanitizer) {}
  ngOnInit(): void {
    this.DrawerVisible = false;
    if (this.mediaStructure.type.startsWith('image')) {
      this.isImage = true;
      this.mediaStructure.isImage = true;
      // this.size = 150;
    } else if (this.mediaStructure.type.startsWith('link')) {
      this.isImage = true;
      this.mediaStructure.isImage = true;
    } else {
      this.isImage = false;
      this.mediaStructure.isImage = false;
      //this.size = 100;
    }
    this.fileType = this.getFileTypes();

    
  }
getSanitizedImage(base64: string): SafeResourceUrl {
  const sanitized = this.sanitizer.bypassSecurityTrustResourceUrl(`data:image/jpeg;base64,${base64}`);
  return sanitized;
}

  onDeleteBtn() {
    this.remove.emit(this.mediaStructure);
  }
  onPreviewBtn() {
    this.preview.emit(this.mediaStructure);
  }

  onDownloadBtn() {
    this.download.emit(this.mediaStructure);
  }
  ShowDrawer() {
    this.DrawerVisible = true;
  }
  onDrawerClose(event: any) {
    this.DrawerVisible = false;
    this.CloseDrawer.emit(this.mediaStructure);
  }
  onRoleSelect() {
    this.RoleChanges.emit(this.mediaStructure);
  }
  getFileTypes(): FileType {
    const fileTypes: FileType[] = FileTypesData;

    const tmp = fileTypes.find(
      (x) => x.application === this.mediaStructure.appInfo
    );
    return tmp!;
  }
}
